<template>
  <div>
    <!-- Contact -->
    <campaign-form-view />

    <!-- Companies -->
    <campaigns-companies-view />

    <!-- Services -->
    <services-full-view />

    <!-- Testimonials -->
    <campaigns-testimonial-view />

    <!-- Footer -->
    <footer-view />
  </div>
</template>

<script>
import campaigns from '&/static/campaigns/campaigns';

export default {
  name: 'PageCampaign',

  components: {
    CampaignFormView: () => import('@/components/campaigns/campaigns-form-view'),
    CampaignsCompaniesView: () => import('@/components/campaigns/campaigns-companies-view'),
    ServicesFullView: () => import('@/components/services/services-full-view'),
    CampaignsTestimonialView: () => import('@/components/campaigns/campaigns-testimonial-view'),
    FooterView: () => import('@/components/footer/footer-view')
  },

  metaInfo: {
    title: 'Bliss Applications: User-centered design company',
    meta: [
      {
        name: 'description',
        content: 'Bliss Applications is a software developer based in Portugal & Boston specializing in mobile apps for start-ups, consumer marketing & enterprise tools.'
      },
      {
        property: 'og:url',
        content: 'https://www.blissapplications.com/'
      },
      {
        property: 'og:title',
        content: 'Bliss Applications: User-centered design company'
      },
      {
        property: 'og:description',
        content: 'Bliss Applications is a software developer based in Portugal & Boston specializing in mobile apps for start-ups, consumer marketing & enterprise tools.'
      },
      {
        property: 'og:image',
        content: 'https://drive.google.com/file/d/135aIMh5U9N4BSuF0mYkaRy2nx6LCpq1h/view?usp=sharing'
      },
      {
        name: 'twitter:title',
        content: 'Bliss Applications: User-centered design company'
      },
      {
        name: 'twitter:description',
        content: 'Bliss Applications is a software developer based in Portugal & Boston specializing in mobile apps for start-ups, consumer marketing & enterprise tools.'
      },
      {
        name: 'twitter:image',
        content: 'https://drive.google.com/file/d/135aIMh5U9N4BSuF0mYkaRy2nx6LCpq1h/view?usp=sharing'
      }
    ]
  },

  mounted() {
    const query = this.$route.params.campaign;

    if (campaigns[query] === undefined) {
      this.$router.push({ name: 'campaign_index' });
    }
  }
};
</script>



// WEBPACK FOOTER //
// campaign.vue